module.exports = __webpack_public_path__ + "img/hand_side3_47.8997658d.svg";